module.exports = __webpack_public_path__ + "static/img/advantage1.3f22f3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/advantage1.png
// module id = y43b
// module chunks = 0